import defaultTitle from "../../assets/static/images/holy-wheel/titles/holy-wheel-title-en.webp";
import { resolveSupportedLocale } from "../i18n/locales";

const localizedTitles = import.meta.glob<string>(
    "../../assets/static/images/holy-wheel/titles/holy-wheel-title-*.webp",
    { eager: true, import: "default" },
);
const titlePrefix =
    "../../assets/static/images/holy-wheel/titles/holy-wheel-title-";

export function holyWheelTitle(language: string, resolvedLanguage?: string) {
    const locale = resolveSupportedLocale(language, resolvedLanguage);
    return (
        localizedTitles[`${titlePrefix}${locale.toLowerCase()}.webp`] ??
        defaultTitle
    );
}
